// ** React Imports
import { useState, useEffect, SyntheticEvent } from 'react'

import appInfo from '../../../../configs/app-info';

import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import CardHeader from '@mui/material/CardHeader'
import Button from '@mui/material/Button'
import Typography from '@mui/material/Typography'
import CardContent from '@mui/material/CardContent'
import Grid, { GridProps } from '@mui/material/Grid';
import { styled, useTheme } from '@mui/material/styles'
import FormControl from '@mui/material/FormControl'
import TextField from '@mui/material/TextField'
import FormHelperText from '@mui/material/FormHelperText'
import CircularProgress from '@mui/material/CircularProgress'
import FormLabel from '@mui/material/FormLabel'
import {
    CardActions,
    Divider,
    IconButton,
    InputAdornment,
    Radio,
    RadioGroup,
    Tooltip,
    Fab,
    FormControlLabel,
    Checkbox,
    OutlinedInput,
    Rating,
    Autocomplete
} from '@mui/material'

import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'

import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'

import { useNavigate } from "react-router-dom";
import { Controller, useForm } from 'react-hook-form'
import axios from 'axios'
import Swal from 'sweetalert2'

import Icon from '../../../../components/icon';
import MsiDatagridDynamic from '../../../../components/custom/MsiDatagridDynamic';
import apiUrl from '../../../../configs/constant';

export default function Add() {
    const userData = JSON.parse(localStorage.getItem('user')!)
    const user = userData.data
    const token = userData.token

    const cabang = JSON.parse(localStorage.getItem('cabang')!)

    // ** State
    const [valDoctag, setValDoctag] = useState<any>(null)
    const [listDoctag, setListDoctag] = useState<any[]>([])

    const [valSupplierClass, setValSupplierClass] = useState<any>(null)
    const [listSupplierClass, setListSupplierClass] = useState<any[]>([])

    useEffect(() => {
        getDoctag()
        getSupplierClass()
    }, [])

    const navigate = useNavigate();

    const getDoctag = () => {
        const url = apiUrl.apiUrl + '/system/doctag/list-combo'
        axios
            .get(url, {
                params: {
                    syscabang_id: cabang,
                    sysmenu_id: 46
                },
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListDoctag(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })

    }

    const getSupplierClass = () => {
        const url = apiUrl.apiUrl + '/purchasing/kelas-supplier/list-combo'
        axios
            .get(url, {
                params: {},
                headers: { Authorization: `Bearer ${token}` }
            })
            .then(response => {
                if (response.data.success) {
                    const data = response.data.data
                    setListSupplierClass(data)
                } else {
                    Swal.fire({
                        title: 'Pemberitahuan',
                        text: response.data.message,
                        icon: 'error'
                    })
                }
            })
    }

    const handleChangeAutocompleteDoctag = (event: SyntheticEvent, newValue: any | null) => {
        setValue('sysdoctag_id', newValue?.id)
        setValDoctag(newValue)
    }

    const handleChangeAutocompleteSupplierClass = (event: SyntheticEvent, newValue: any | null) => {
        setValue('pbsupplier_class_id', newValue?.id)
        setValSupplierClass(newValue)
    }

    interface FormInputs {
        syscabang_id: any,
        sysdoctag_id: any,
        pbsupplier_class_id: any,
        eta: any,
        nama: any,
        nama2: any,
        alamat: any,
        telp: any,
        wa: any,
        is_ktp: any,
        npwp: any,
        email: any,
        nama_bank: any,
        nomor_bank: any,
        payment: any,
        plafon: any
    }

    const defaultValues = {
        syscabang_id: cabang
    }

    const {
        control,
        handleSubmit,
        setValue,
        getValues,
        formState: { errors }
    } = useForm<FormInputs>({ defaultValues })

    const onSubmit = (data: any) => {
        Swal.fire({
            title: 'Konfirmasi',
            text: 'Apakah anda ingin menyimpan data ini ?',
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#337ab7',
            cancelButtonColor: '#ffc107',
            confirmButtonText: 'Simpan'
        }).then(result => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: 'Now loading',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading()
                    }
                })

                const url = apiUrl.apiUrl + '/purchasing/supplier/add'
                axios
                    .post(url, data, {
                        headers: { Authorization: `Bearer ${token}` }
                    })
                    .then(response => {
                        if (response.data.success) {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'success',
                                timer: 1000,
                                timerProgressBar: true,
                                willClose: () => {
                                    navigate('/purchasing/supplier')
                                }
                            })
                        } else {
                            Swal.fire({
                                title: 'Pemberitahuan',
                                text: response.data.message,
                                icon: 'error'
                            })
                        }
                    })
                    .catch(error => {
                        Swal.fire({
                            title: 'Pemberitahuan',
                            text: error.message,
                            icon: 'error'
                        })
                    })
            }
        })
    }

    return (
        <Grid container spacing={6} sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
            <Grid item xl={12} md={12} xs={12}>
                <Fab variant='extended' color='primary' sx={{ '& svg': { mr: 1 } }} onClick={() => window.history.back()}>
                    <Icon icon='mdi:arrow-left' />
                    Kembali
                </Fab>
                <div className={'content-block dx-card'} style={{ paddingRight: 20, paddingLeft: 20, paddingBottom: 10, paddingTop: 10 }}>
                    <Typography variant='h5' sx={{ textAlign: 'center' }}>
                        Buat Master Supplier
                    </Typography>
                    <Divider sx={{ m: 0 }} />
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <Grid container spacing={3}>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Document Tag
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='sysdoctag_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valDoctag}
                                                options={listDoctag}
                                                id='sysdoctag_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteDoctag}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Document Tag'
                                                        error={Boolean(errors.sysdoctag_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.sysdoctag_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Kelas Supplier
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='pbsupplier_class_id'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <Autocomplete
                                                value={valSupplierClass}
                                                options={listSupplierClass}
                                                id='pbsupplier_class_id'
                                                isOptionEqualToValue={(option: any, value: any) => option.id === value.id}
                                                onChange={handleChangeAutocompleteSupplierClass}
                                                renderOption={(props: any, option: any) => {
                                                    return (
                                                        <li {...props} key={option.id}>
                                                            {option.nama}
                                                        </li>
                                                    )
                                                }}
                                                getOptionLabel={(option: any) => option.nama}
                                                renderInput={(params: any) => (
                                                    <TextField
                                                        {...params}
                                                        label='Kelas Supplier'
                                                        error={Boolean(errors.pbsupplier_class_id)}
                                                        InputLabelProps={{ shrink: true }}
                                                    />
                                                )}
                                            />
                                        )}
                                    />
                                    {errors.pbsupplier_class_id && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Customer
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Customer'
                                                error={Boolean(errors.nama)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Customer (Kode)
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama2'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Customer (Kode)'
                                                error={Boolean(errors.nama2)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama2 && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    NPWP
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='npwp'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='NPWP'
                                                error={Boolean(errors.npwp)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.npwp && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    No. HP (WA)
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='wa'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='No. HP (WA)'
                                                error={Boolean(errors.wa)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.wa && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Telp
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='telp'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Telp'
                                                error={Boolean(errors.telp)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.telp && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Email
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='email'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Email'
                                                type='email'
                                                error={Boolean(errors.email)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.email && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    TOP
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='payment'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='TOP'
                                                type='number'
                                                error={Boolean(errors.payment)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.payment && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    ETA
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='eta'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='ETA'
                                                type='number'
                                                error={Boolean(errors.eta)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.eta && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>

                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Plafon
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='plafon'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Plafon'
                                                type='number'
                                                error={Boolean(errors.plafon)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.plafon && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'flex-start'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                        <Typography variant='body1' sx={{ fontWeight: 500, mb: 1.5 }}>
                                            KTP ?
                                        </Typography>
                                        <FormControl fullWidth>
                                            <Controller
                                                name='is_ktp'
                                                control={control}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange } }) => (
                                                    <FormControlLabel
                                                        sx={{ marginBottom: 0 }}
                                                        control={
                                                            <Checkbox
                                                                checked={Boolean(value)}
                                                                onChange={e => {
                                                                    const isChecked = e.target.checked;
                                                                    onChange(isChecked ? 1 : 0);
                                                                }}
                                                                sx={errors.is_ktp ? { color: 'error.main' } : null}
                                                            />
                                                        }
                                                        label='KTP ?'
                                                    />
                                                )}
                                            />
                                            {errors.is_ktp && (
                                                <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Alamat Lengkap
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='alamat'
                                        control={control}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Alamat Lengkap'
                                                multiline
                                                rows={2}
                                                error={Boolean(errors.alamat)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.alamat && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nama Rekening
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nama_bank'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nama Rekening'
                                                error={Boolean(errors.nama_bank)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nama_bank && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                <Typography variant='body1' sx={{ fontWeight: 'bold', mb: 1, mt: 1 }}>
                                    Nomor Rekening
                                </Typography>
                                <FormControl fullWidth>
                                    <Controller
                                        name='nomor_bank'
                                        control={control}
                                        rules={{ required: false }}
                                        render={({ field: { value, onChange } }) => (
                                            <TextField
                                                label='Nomor Rekening'
                                                type='number'
                                                error={Boolean(errors.nomor_bank)}
                                                onChange={onChange}
                                                value={value}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                    {errors.nomor_bank && (
                                        <FormHelperText sx={{ color: 'error.main' }}>Form ini tidak boleh kosong.</FormHelperText>
                                    )}
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Box
                                    sx={{
                                        width: '100%',
                                        display: 'flex',
                                        flexWrap: 'wrap',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', mt: 4 }}>
                                        <Button variant='contained' type='submit'
                                        >
                                            SIMPAN
                                        </Button>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </form>
                </div>
            </Grid>
        </Grid>
    )
}
